import { formatNumber } from '@mais-retorno-front/helpers/util-helpers';
import {
  capitalyzeText,
  formatCnpj,
} from '@mais-retorno-front/libs/util-helpers';
import { AxiosInstance } from 'axios';

export interface IManagerFunds {
  id: number;
  name: string;
  pagination: IPagination;
  items: IManagerAsset[];
  notFound?: boolean;
  destination?: string;
  funds: IFunds[];
}

interface IPagination {
  page: number;
  pages_quantity: number;
  total: number;
}

interface IManagerAsset {
  slug: string;
  id: number;
  nicename: string;
  networth: number;
  status: IFundStatsType;
  fund_class: {
    class: IFundClass;
    subclass: IFundClass;
  };
  quota_holders: string;
}

type IFundStatsType = 'operacional' | 'pre-operacional' | 'cancelado';

interface IFundClass {
  name: string;
  slug: string;
}

interface IFunds {
  mainInfo: {
    name: string;
    additionalText: string;
    link: string;
  };
  data: {
    slug: string;
    name: string;
    value: string;
  }[];
}

interface IManagerFundsReturn {
  id: number;
  name: string;
  pagination: IPagination;
  funds: IFunds[];
}

export class GetFundsManagerUseCase {
  constructor(private readonly http: AxiosInstance) {}
  async execute(managerSlug: string, page = 1): Promise<IManagerFundsReturn> {
    const { data } = await this.http.get<IManagerFunds>(
      `/asset-managers/details/${managerSlug}/funds?page=${page}`
    );

    return {
      id: data?.id || null,
      name: data?.name || null,
      pagination: {
        page: data.pagination.page,
        pages_quantity: data.pagination.pages_quantity,
        total: data.pagination.total,
      },
      funds:
        data?.items.map((fund) => {
          return {
            mainInfo: {
              name: fund?.nicename || null,
              additionalText: formatCnpj(fund?.id)?.toString() || null,
              link: `fundo/${fund.slug}`,
            },
            data: [
              {
                slug: fund?.slug || null,
                name: fund?.fund_class?.class?.name || null,
                value: fund?.fund_class?.subclass?.name || null,
              },
              {
                slug: 'status',
                name: 'Status',
                value: capitalyzeText(fund.status) || null,
              },
              {
                slug: 'pl',
                name: 'PL',
                value:
                  formatNumber(fund?.networth, {
                    type: 'money',
                    thousandMask: true,
                  }) || null,
              },
              {
                slug: 'cotistas',
                name: 'Cotistas',
                value: formatNumber(fund.quota_holders, {
                  thousandMask: true,
                  decimalPlaces: 2,
                }),
              },
            ],
          };
        }) || null,
    };
  }
}
